import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PpoListService } from '../../../service/ppo-list/ppo-list.service';
import { productCodes } from 'src/app/utility/enum/global-enum';

@Component({
  selector: 'app-viewletter-dialog',
  templateUrl: './viewletter-dialog.component.html',
  styleUrls: ['./viewletter-dialog.component.scss']
})
export class ViewletterDialogComponent implements OnInit {

  ppoRequestId: number;
  balanceList: any[] = [];
  lastHospitalWithPendingBalance: string;
  exclusionString = '';
  inclusionString = '';
  today = new Date();
  product : any;
  isServiceDate: boolean = false;
  productCode: string;
  isOPProduct = false;

  ppoRequestForm = this.fb.group({
    hospitalName: [{ value: "", disabled: true }],
    ppoCode: [{ value: "", disabled: true }],
    policyNumber: [{ value: "", disabled: true }],
    certificateNumber: [{ value: "", disabled: true }],
    patientNameRel: [{ value: "", disabled: true }],
    productName: [{ value: "", disabled: true }],
    isPregnant: [{ value: "", disabled: true }],
    admissionDate: [{ value: "", disabled: true }],
    disease: [{ value: "", disabled: true }],
  });

  constructor(
    private ppoService: PpoListService,
    private fb: FormBuilder,
    private messageService: MessageService,
    public dialogRef: MatDialogRef<ViewletterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data > 0) {
      this.ppoRequestId = this.data;
      this.ppoRequestDetails();
    }
  }

  ppoRequestDetails() {
    this.ppoService.getPpoRequestDetails(this.ppoRequestId).subscribe(
      res => {
        if (res != null) {
          this.productCode = res.productCode;
          if (this.productCode === productCodes.OutPatient_OP) {
            this.isOPProduct = true;
          }
          this.loadData(res);
          this.updateServiceDate(this.productCode);
        }
      });
  }

  loadData(data) {
    this.ppoRequestForm.patchValue(data);
    this.loadBalanceInfo(this.ppoRequestId);
  }

  loadBalanceInfo(id: number) {
    this.ppoService.getPPOBalance(id)
      .subscribe(res => {
        this.balanceList = res;
        const exclusions = this.balanceList.map(balance => balance.exclusion);
        this.exclusionString = this.filterDuplicate(exclusions);

        const inclusions = this.balanceList.map(balance => balance.inclusion);
        this.inclusionString = this.filterDuplicate(inclusions);
      });

    this.ppoService.getLastHospitalWithPendingBalance(id)
      .subscribe(res => this.lastHospitalWithPendingBalance = res);
  }

  getPreviousHospital() {
    return this.lastHospitalWithPendingBalance ? this.lastHospitalWithPendingBalance : '';
  }

  filterDuplicate(items : string[]) {
    const distinctItems = [... new Set(items)];
    return distinctItems.filter(item => item != null).join(', ');
  }

  updateServiceDate(productCode: string) {
    // let productNames = ['Out-Patient (Yearly)', 'Out-Patient', 'Out-Patient (Per Disability)'];
    let pCodes = [productCodes.OutPatient_OP, productCodes.OutPatient_Per_Disability];
    if (pCodes.includes(productCode)) {
      this.isServiceDate = true;
    }
    else {
      this.isServiceDate = false;
    }
  }

}
